import { actions, selectors } from 'data'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { current } from 'services/api/user'

const CHECK_INTERVAL = 1000 * 10
const SessionMonitor = () => {
  const user = useSelector(selectors.auth.getUser)
  const dispatch = useDispatch()

  const checkSession = async () => {
    const res = await current()
    if (!res.ok && res.error.cause === 'Unknown session') {
      dispatch(actions.auth.signout())
    }
  }
  useEffect(
    function checkSessionHook() {
      if (!user) return // No session, nothing to monitor
      const interval = setInterval(checkSession, CHECK_INTERVAL)
      return () => clearInterval(interval)
    },
    [user]
  )
  return null
}

export default SessionMonitor
